/* eslint-disable */

import React from 'react';
import moment from 'moment';
import 'react-dates/lib/css/_datepicker.css';
import Select from 'react-select';

export default class FieldReferenceSelector extends React.Component {

  state = {
    options: null
  };

  componentDidMount() {
    const { loadSalesforceReferenceFieldOptions } = this.props;

    loadSalesforceReferenceFieldOptions().then(response => {
      this.setState({options: response.data});
    });
  };

  render() {
    if (!this.state.options)
      return null;
    const selectValue = this.state.options.find(option => option.value === this.props.value);
    return (<Select
      value={selectValue}
      options={this.state.options}
      onChange={this.props.onChange}
    />);
  }
}
